const LogoSingleColor = () => (
	<svg width={24} height={24} fill="none">
		<path
			fill="#fff"
			fillRule="evenodd"
			d="M22.594 5h-4.727a.413.413 0 0 0-.386.278L15.32 11.26l-3.159.107 2.258-6.08c.05-.139-.05-.287-.193-.287H9.252a.412.412 0 0 0-.384.272l-2.335 6.279a552.31 552.31 0 0 1-3.401.097.412.412 0 0 0-.374.273l-.744 2.007c-.053.142.05.293.197.288.872-.029 2.017-.073 3.38-.128L3.588 19.47c-.056.146.054.302.205.29a658.77 658.77 0 0 1 5.139-.391c.16-.012.3-.118.357-.273l1.949-5.247c1.021-.044 2.09-.09 3.194-.136l-1.843 5.1c-.052.145.055.297.205.287 1.54-.103 3.146-.206 4.816-.307a.415.415 0 0 0 .363-.275l4.813-13.235c.05-.138-.05-.284-.193-.284"
			clipRule="evenodd"
		/>
	</svg>
);
export default LogoSingleColor;
